import { API_ENDPOINT } from ".";

export const sendForm = async (obj: any) => {
  try {
    const response = await fetch(`${API_ENDPOINT}/send-form`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    });
    return response.status;
  } catch (err) {
    console.log(err);
  }
};
export const getClientInfo = async (obj: any) => {
  try {
    const response = await fetch(`${API_ENDPOINT}/get-client-info`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.status;
  } catch (err) {
    console.log(err);
  }
};
